import axios from 'axios'
import { apiObject } from './apiobject'

const contact = {
  ...apiObject,
  url: '/userforms/contacts/',
  getLogin (obj) {
    return new Promise((resolve, reject) => {
      axios.get(`${this.url}${obj.id}/getlogin/`)
        .then(response => {
          resolve(response.data)
        }, error => {
          reject(error)
        })
    })
  },
  sendMessage (obj, messageObject) {
    return new Promise((resolve, reject) => {
      axios.post(`${this.url}${obj.id}/message/`, messageObject)
        .then(response => {
          resolve(response.data)
        }, error => {
          reject(error)
        })
    })
  },
  uploadFile (obj, fileUpload, onUploadProgress=null) {
    return axios.post(`${this.url}${obj.id}/uploadfile/`,
      fileUpload,
      {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: onUploadProgress
      }
    )
  },
  deleteFile (obj, fileDownload) {
    return new Promise((resolve, reject) => {
      axios.delete(`${this.url}${obj.id}/uploads/${fileDownload}/`)
        .then(() => {
          resolve()
        }, error => {
          reject(error)
        })
      })
  },
  downloadCsv ({ search, ordering, filter = {} } = {}) {
    var paramObject = Object.assign({ search, ordering }, filter)
    return axios.get(`${this.url}csv/`, {
      params: paramObject,
      responseType: 'arraybuffer'
    })
  },
  downloadFile (obj, fileDownload) {
    return axios.get(`${this.url}${obj.id}/uploads/${fileDownload}`, {
      responseType: 'arraybuffer'
    })
  },
  ignoreEmailProblems (email) {
    return new Promise((resolve, reject) => {
      axios.patch(`${this.url}ignoreemailproblems/`, email)
        .then((data) => {
          resolve(data)
        }, error => {
          reject(error)
        })
    })
  },
  resetDemoState (obj) {
    return new Promise((resolve, reject) => {
      axios.patch(`${this.url}${obj.id}/resetdemostate/`)
        .then((data) => {
          resolve(data)
        }), error => {
          reject(error)
        }
    })
  }
}

const contactNotifications = {
  url: '/notifications/contact/',
  get (object, { search, ordering, pageNum = 1, count = 10, filter = {} } = {}, ignoreErrorHandle = false) {
    var paramObject = Object.assign({}, { search, ordering, page: pageNum, count }, filter)
    return new Promise((resolve, reject) => {
      axios.get(`${this.url}${object.id}/`, {
        params: paramObject,
        ignoreErrorHandle: ignoreErrorHandle
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  read (contact, obj, read = true) {
    return new Promise((resolve, reject) => {
      axios.put(`${this.url}${contact.id}/${obj.id}/read/`, {
        read: read
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const userForm = {
  ...apiObject,
  url: '/userforms/userforms/',
  resendEsign (userFormId) {
    return new Promise((resolve, reject) => {
      axios.post(`${this.url}${userFormId}/resendesign/`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  submit (userFormId) {
    return new Promise((resolve, reject) => {
      axios.post(`${this.url}${userFormId}/submit/`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  saveAnswer (userFormId, questionId, answer) {
    answer.question_id = questionId // TODO: do this better
    // answer expected in format { answer, list_id }
    return new Promise((resolve, reject) => {
      axios.put(`${this.url}${userFormId}/answer/`,
                answer, {ignoreErrorHandle: [400, 0]})
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  saveFileAnswer (userFormId, answerObject) {
    return new Promise((resolve, reject) => {
      axios.put(`${this.url}${userFormId}/answer/`,
        answerObject,
        {
          headers: {
              'Content-Type': 'multipart/form-data'
          },
          ignoreErrorHandle: [400, 0]
        })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  downloadFileAnswer (userFormId, answerObject) {
    return axios.get(`${this.url}${userFormId}/download/`,
      {
        params: answerObject,
        responseType: 'arraybuffer'
      }
    )
  },
  deleteRow (userFormId, questionId, fieldTypeId, listId) {
    return new Promise((resolve, reject) => {
      let answerList = {
        question_id: questionId,
        fieldtype_id: fieldTypeId,
        list_id: listId
      }
      axios.delete(`${this.url}${userFormId}/deleterow/`,
        {data: answerList})
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  changeAnswerStatus (userFormId, questionId, fieldTypeId, listId, clientId, status) {
    let answer = {
      question_id: questionId,
      fieldtype_id: fieldTypeId,
      list_id: listId,
      client_id: clientId,
      status: status
    }
    return new Promise((resolve, reject) => {
      axios.post(`${this.url}${userFormId}/answerstatus/`,
                 answer)
        .then(response => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
    })
  },
  getNotes (userFormId, questionId, fieldTypeId, listId) {
    let query = {
      question_id: questionId,
      fieldtype_id: fieldTypeId,
      list_id: listId
    }
    return new Promise((resolve, reject) => {
      axios.get(`${this.url}${userFormId}/notes/`,
                { params: query })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getEsigns (userFormId) {
    return new Promise((resolve, reject) => {
      axios.get(`${this.url}${userFormId}/esign/`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  uploadEsign (userFormId, formData) {
    return new Promise((resolve, reject) => {
      axios.post(`${this.url}${userFormId}/esign/`, formData)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateEsign (userFormId, envelope_id) {
    return new Promise((resolve, reject) => {
      axios.patch(`${this.url}${userFormId}/esign/`, {
        'envelope_id': envelope_id
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  pollEsign (userFormId) {
    return new Promise((resolve, reject) => {
      axios.post(`${this.url}${userFormId}/pollesign/`, null, {ignoreErrorHandle: true})
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  move (userFormId, toId) {
    return new Promise((resolve, reject) => {
      axios.post(`${this.url}${userFormId}/move/`, { to: toId })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getActivity (userFormId) {
    return new Promise((resolve, reject) => {
      axios.get(`${this.url}${userFormId}/activity/`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getAnswerDb (userFormId) {
    return new Promise((resolve, reject) => {
      axios.get(`${this.url}${userFormId}/answers/`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  downloadEsign (userFormId, envelopeId, original) {
    return axios.get(`${this.url}${userFormId}/esign/download/${envelopeId}/`,
      {
        params: {
          'original': original
        },
        responseType: 'arraybuffer'
      }
    )
  },
  addNote (userFormId, questionId, fieldTypeId, listId, clientId, text) {
    let note = {
      question_id: questionId,
      fieldtype_id: fieldTypeId,
      list_id: listId,
      client_id: clientId,
      text: text
    }
    return new Promise((resolve, reject) => {
      axios.put(`${this.url}${userFormId}/note/`, note)
        .then(response => {
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
    })
  },
  downloadPdf (userFormId, request = null) {
    return axios.get(`${this.url}${userFormId}/pdf/`, {
      responseType: 'arraybuffer',
      params: {
        request: request
      }
    })
  },
  downloadCsv ({ search, ordering, filter = {} } = {}) {
    var paramObject = Object.assign({ search, ordering }, filter)
    return axios.get(`${this.url}csv/`, {
      params: paramObject,
      responseType: 'arraybuffer'
    })
  },
  downloadPdfZip ({ search, filter = {}, type, name } = {}) {
    var paramObject = Object.assign({ search, type, name }, filter)
    return axios.get(`${this.url}pdfdownload/`, {
      params: paramObject,
      responseType: 'arraybuffer'
    })
  },
  downloadContactPdf (userFormId) {
    return axios.get(`${this.url}${userFormId}/contactpdf/`, {
      responseType: 'arraybuffer'
    })
  }
}

const tagObject = {
  get (search) {
    return new Promise((resolve, reject) => {
      axios.get(`${this.url}`, {
        params: {search}
      })
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  getSubs () {
    return new Promise((resolve, reject) => {
      axios.get(`/userforms/subscriptions/${this.type}/`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  updateSub (tag) {
    return new Promise((resolve, reject) => {
      axios.put(`/userforms/subscriptions/${this.type}/${tag.slug}/`,
                tag, {ignoreErrorHandle: true})
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  deleteSub (tag) {
    return new Promise((resolve, reject) => {
      axios.delete(`/userforms/subscriptions/${this.type}/${tag.slug}/`,
                tag, {ignoreErrorHandle: true})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  }
}

const adminTagObject = {
  getSubs (user_id) {
    return new Promise((resolve, reject) => {
      axios.get(`${this.url}${user_id}/${this.type}/`)
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  updateSub (user_id, tag) {
    return new Promise((resolve, reject) => {
      axios.put(`${this.url}${user_id}/${this.type}/${tag.slug}/`,
                tag, {ignoreErrorHandle: true})
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  deleteSub (user_id, tag) {
    return new Promise((resolve, reject) => {
      axios.delete(`${this.url}${user_id}/${this.type}/${tag.slug}/`,
                tag, {ignoreErrorHandle: true})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  }
}

const userformTags = {
  url: '/userforms/userforms/tags/',
  type: 'userforms',
  ...tagObject,
}

const contactTags = {
  url: '/userforms/contacts/tags/',
  type: 'contacts',
  ...tagObject,
}

const adminUserformTags = {
  url: '/userforms/subscriptions/',
  type: 'userforms',
  ...adminTagObject,
}

const adminContactTags = {
  url: '/userforms/subscriptions/',
  type: 'contacts',
  ...adminTagObject,
}

const contactUserForm = {
  ...apiObject,
  ...userForm,
  url: '/userforms/contactuserforms/',
  getDocuSign (userFormId) {
    return new Promise((resolve, reject) => {
      axios.get(`${this.url}${userFormId}/sign/`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  submit (userFormId, signature = null, location = null) {
    return new Promise((resolve, reject) => {
      axios.post(`${this.url}${userFormId}/submit/`, {
        signature: signature,
        location: location
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
}

const contactCases = {
  ...apiObject,
  url: '/userforms/contactcases/'
}

const contactFiles = {
  url: '/userforms/files/',
  getFiles () {
    return new Promise((resolve, reject) => {
      axios.get(`${this.url}?ordering=created_at`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  download (id) {
    return axios.get(`${this.url}download/${id}/`, {
      responseType: 'arraybuffer'
    })
  },
  deleteFile (fileDownload) {
    return new Promise((resolve, reject) => {
      axios.delete(`${this.url}delete/${fileDownload}/`)
        .then(() => {
          resolve()
        }, error => {
          reject(error)
        })
    })
  },
  uploadFiles (fileUpload, progressUploadEvent) {
    return axios.post(`${this.url}`,
      fileUpload,
      {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: ((progressEvent) => {
          progressUploadEvent(progressEvent)
        })
      }
    )
  },
}

const contactFilesPage = {
  ...apiObject,
  url: '/userforms/contactfiles/',
  downloadCsv ({ search, ordering, filter = {} } = {}) {
    var paramObject = Object.assign({ search, ordering }, filter)
    return axios.get(`${this.url}csv/`, {
      params: paramObject,
      responseType: 'arraybuffer'
    })
  },
}

const contactSettings = {
  url: '/userforms/settings/',
  get (ignoreErrorHandle = false) {
    return new Promise((resolve, reject) => {
      axios.get(`${this.url}`, {ignoreErrorHandle: ignoreErrorHandle})
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  },
  save (settings, ignoreErrorHandle = false) {
    return new Promise((resolve, reject) => {
      axios.post(`${this.url}`, settings, {ignoreErrorHandle: ignoreErrorHandle})
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error.response)
        })
    })
  }
}

const superAdminTagSearch = {
  url: '/userforms/tags/',
  getContactTags (id, search) {
    return new Promise((resolve, reject) => {
      axios.get(`${this.url}contacts/${id}/`, {
        params: {search}
      })
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
  getUserformTags (id, search) {
    return new Promise((resolve, reject) => {
      axios.get(`${this.url}userforms/${id}/`, {
        params: {search}
      })
      .then(response => {
        resolve(response.data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },
}

export default {
  contact,
  contactNotifications,
  userForm,
  contactUserForm,
  contactFiles,
  userformTags,
  contactCases,
  contactTags,
  adminUserformTags,
  adminContactTags,
  contactFilesPage,
  contactSettings,
  superAdminTagSearch
}
